import React, { useState, useRef, useEffect } from 'react'

import FormLabel from 'components/common/forms/elements/FormLabel'
import Card from 'components/common/cards/Card'
import Button from 'components/common/Button'
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'
import DokaImageEditor from 'components/common/DokaImageEditor'
import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'

import styled from 'styled-components'
import { COLORS } from 'utility/colors'

const HeadshotUploadCard = styled(Card)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	aspect-ratio: ${({ aspectRatio }) => aspectRatio};
	align-items: center;
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	margin-bottom: 10px;
	padding: 5px;
	position: relative;
	border: ${({ withBorder, borderColor }) => (withBorder ? `5px solid ${borderColor}` : '0px')};
	:hover {
		cursor: pointer;
	}
`

const labelColorStyle = {
	color: COLORS.GRAY,
	fontWeight: 'bold',
	fontSize: '14px',
	marginBottom: 7,
}

const MissingAvatarPlaceholder = ({
	icon = 'user',
	title = 'Upload Logo',
	copy = 'Please use a square image',
}) => {
	return (
		<div style={{ textAlign: 'center' }}>
			<Icon icon={icon} color={COLORS.GRAY} solid size={36} style={{ height: 'auto' }} />
			<Text
				align='center'
				color={COLORS.GRAY}
				size={16}
				bold
				style={{
					paddingTop: 5,
					paddingBottom: 0,
					marginBottom: 0,
				}}
			>
				{title}
			</Text>
			<Text
				color={COLORS.GRAY}
				size={10}
				align={'center'}
				style={{
					paddingBottom: 0,
					paddingRight: 5,
					paddingLeft: 5,
					margin: 0,
					lineHeight: 1.3,
				}}
			>
				{copy}
			</Text>
		</div>
	)
}

export const ImageUploaderWithCrop = ({
	label = 'HEADSHOT (or LOGO)',
	icon = 'user',
	defaultImagePreview = '',
	buttonLabel = 'Select Headshot',
	acceptedFileTypes = 'image/png, image/jpeg',
	maxWidth = 200,
	aspectRatio = 1,
	backgroundColor = COLORS.WHITE,
	enabledButton = false,
	onChangeFile = (file) => {
		console.log('File: ', file)
	},
}) => {
	const fileRef = useRef(null)

	const [showCropModal, setShowCropModal] = useState(false)

	const [file, setFile] = useState(null)
	const [filePreview, setFilePreview] = useState(defaultImagePreview)

	useEffect(() => {
		if (file) onChangeFile(file)
	}, [file])

	const handleAvatarChange = async (event) => {
		const file = event?.target?.files && event.target.files[0]
		if (!file) return

		const fileUrl = URL.createObjectURL(file)
		setFile(file)
		setFilePreview(fileUrl)
		setShowCropModal(true)
	}

	const handleButtonClick = () => {
		fileRef && fileRef.current && fileRef.current.click()
	}

	const { data: tenantProfile } = useTenantProfile()
	const primaryColor = tenantProfile?.theme?.primaryColor

	return (
		<>
			<FormLabel style={labelColorStyle}>{label}</FormLabel>
			<div>
				<HeadshotUploadCard
					withBorder={filePreview ? false : true}
					aspectRatio={aspectRatio}
					borderColor={primaryColor}
					style={{
						maxWidth,
						backgroundColor,
						backgroundImage: filePreview ? `url(${filePreview})` : 'none',
					}}
					onClick={handleButtonClick}
				>
					{!filePreview && (
						<MissingAvatarPlaceholder
							icon={icon}
							title={buttonLabel}
							copy='JPG, GIF, PNG & max size of 800K'
						/>
					)}
					{enabledButton && (
						<Button
							type='button'
							style={{
								position: 'absolute',
								bottom: 10,
								paddingLeft: 30,
								paddingRight: 30,
								paddingTop: 10,
								paddingBottom: 10,
								fontSize: 14,
								width: `calc(100% - 20px)`,
								height: 'auto',
							}}
							background={secondaryColor}
							// onClick={handleButtonClick}
						>
							{buttonLabel}
						</Button>
					)}
					<input
						type='file'
						id='avatar'
						accept={acceptedFileTypes}
						ref={fileRef}
						onChange={handleAvatarChange}
						onClick={(event) => (event.target.value = null)}
						style={{ display: 'none' }}
					/>
				</HeadshotUploadCard>
			</div>
			{showCropModal && (
				<DokaImageEditor
					aspectRatio={aspectRatio}
					onFinish={(imageData) => {
						setFile(imageData.dest) // this is a full file
						setFilePreview(imageData.finalImageFileUrl) // this is the file url
						setShowCropModal(false)
					}}
					onClose={() => setShowCropModal(false)}
					src={filePreview}
				/>
			)}
		</>
	)
}
